<div
  ngbDropdown
  class="d-inline-block"
  autoClose="outside"
  container="body"
  placement="left"
  display="dynamic"
  #dropdown="ngbDropdown"
>
  <fa-icon
    [icon]="faEllipsisV"
    class="doc-menu-trigger pl-3 pr-2 icon-color fa-lg"
    id="dropdownMenu1"
    ngbDropdownToggle
  >
  </fa-icon>
  <div class="dropdown-menu" aria-labelledby="dropdownMenu1" ngbDropdownMenu>
    <div *ngIf="loading" class="loadingState">
      <app-dc-loading [lightBackground]="true"></app-dc-loading>
    </div>
    <ng-container *ngIf="status !== statuses.NOT_AVAILABLE">
      <button
        class="dropdown-item"
        (click)="action(actions.PREVIEW)"
        ngbDropdownItem
      >
        <img class="mr-2 svgIcon" src="assets/info-icon.svg" /> Preview
      </button>
      <button
        class="download-doc dropdown-item download"
        (click)="action(actions.DOWNLOAD)"
        ngbDropdownItem
      >
        <img class="mr-2 svgIcon" src="assets/download-file.svg" /> Download
      </button>
    </ng-container>
    <ng-container *ngIf="status !== statuses.NOT_AVAILABLE">
      <button
        class="dropdown-item compare"
        (click)="action(actions.COMPARE)"
        ngbDropdownItem
      >
        <img class="mr-2 svgIcon" src="assets/compare.svg" /> Compare
      </button>
    </ng-container>
    <ng-container *ngIf="status !== statuses.NOT_AVAILABLE && previousDocument">
      <button
        class="dropdown-item compare"
        (click)="compareWithPrevious()"
        ngbDropdownItem
      >
        <img class="mr-2 svgIcon" src="assets/compare.svg" /> Compare with
        Previous
      </button>
    </ng-container>
    <ng-container *ngIf="status === statuses.IN_REVIEW">
      <button
        class="dropdown-item"
        (click)="action(actions.APPROVE)"
        ngbDropdownItem
      >
        <img class="mr-2 svgIcon" src="assets/approve.svg" /> Approve
      </button>
      <button
        class="dropdown-item"
        (click)="action(actions.REJECT)"
        ngbDropdownItem
      >
        <img class="mr-2 svgIcon" src="assets/reject.svg" /> Reject
      </button>
    </ng-container>

    <button
      class="dropdown-item delete"
      (click)="action(actions.DELETE)"
      ngbDropdownItem
      *restrictTo="'DELETE_DOCUMENTS'"
    >
      <img class="mr-2 svgIcon" src="assets/bin.svg" /> Delete
    </button>
  </div>
</div>
